import Experience from "./Experience";
import ListCount from "./ListCount";

export default class {
    constructor() {
        this.experience = new Experience();
        this.data = [];
        this.setMapDataContainer();


    }
    getReducedTitle(title) {
        if (title.length < 20) {
            return title
        } else {
            return title.slice(0, 19) + '...';
        }

    }
    setData(newData) {
        // Vérifier si les données sont identiques avant de mettre à jour
        newData.sort((a, b) => a.properties.orderOfDisplay - b.properties.orderOfDisplay);
        console.log(newData);


        if (this.isSameData(newData, this.data)) {
            console.log('aucun changement');
            return;
        }

        this.data = newData;
        // design de la liste
        this.listContainer = document.querySelector('.mapContainer .mapDataContainer .listContainer');

        this.listContent = document.querySelector('.mapContainer .mapDataContainer .listContent');
        this.listContent.innerHTML = '';

        this.data.forEach((feature) => {
            const listItemTemplate = document.createElement('template');


            listItemTemplate.innerHTML = `
                <div class="listItem" data-id="${feature.id}">
                    <img class="thumbnail" src="./POI/${feature.properties.fileName}/image.png" alt="" />
                    <div class="info">
                        <div class="textInfo">
                            <p class="title">${this.getReducedTitle(feature.properties.title)}</p>
                            <p class="location">${feature.properties.location}</p>
                        </div>
                        <img src="./POI/${feature.properties.fileName}/logo.png" alt="" class="logo" />
                    </div>
                </div>
            `;
            const listItem = listItemTemplate.content.firstElementChild;
            this.listContent.appendChild(listItem);


            // ? create the article on click on list item
            this.articleCard = document.querySelector('.mapContainer .mapDataContainer .articleCard');

            // interaction avec les items de la liste au click
            listItem.addEventListener('click', (e) => {
                const index = e.currentTarget.dataset.id
                const clickedData = this.data.find(feature => feature.properties.id == index)
                const lon = clickedData.geometry.coordinates[0]
                const lat = clickedData.geometry.coordinates[1]
                // console.log(lon, lat);
                this.experience.map.flyTo({
                    center: [lon + 0.1, lat],  // Les coordonnées du marker
                    essential: true,      // Assure que l'animation est effectuée
                    zoom: 8              // Niveau de zoom que vous souhaitez
                });

                this.openMarker(true, feature)


                this.setArticle(clickedData)

            });
        });
    }

    setArticle(data) {
        const lon = data.geometry.coordinates[0]
        const lat = data.geometry.coordinates[1]
        // disparition de la liste
        this.listContainer.classList.remove('visible')
        // vider l'article
        this.articleCard.innerHTML = ''


        this.closeButton = document.createElement('button')
        this.closeButton.classList.add('closeArticle')
        this.closeButton.innerHTML = `
                                                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.910156" y="0.531494" width="30" height="30" rx="15" fill="black"/>
                                                <path d="M21.9102 9.53149L9.91016 21.5315" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.91016 9.53149L21.9102 21.5315" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                `

        this.articleCard.innerHTML += `
                   <img src="./POI/${data.properties.fileName}/logo.png" alt="" class="logo" />

                
                `
        this.articleCard.appendChild(this.closeButton)

        // disparition liste / apparition article
        this.articleCard.classList.add('visible')
        this.listContainer.classList.remove('visible')
        // 
        // 
        // 
        // 
        // 

        // close article
        this.closeButton.addEventListener('click', (e) => {

            // 
            this.articleCard.classList.remove('visible')
            this.listContainer.classList.add('visible')
            // obtenir le marker relatif et jouer l'animation inverse
            this.openMarker(false, data)


            this.experience.map.flyTo({
                center: [data.geometry.coordinates[0] + 0.01, data.geometry.coordinates[1]],  // Les coordonnées du marker
                essential: true,      // Assure que l'animation est effectuée
                zoom: Math.max(this.experience.map.getZoom() - 5, 1)             // Niveau de zoom que vous souhaitez
            });





        })

    }
    openMarker(bool, data) {
        // console.log(bool);

        const markerElement = this.experience.getMarker(data.properties.id).getElement().children[0];

        markerElement.style.scale = bool ? '2' : '1';
        markerElement.style.setProperty('--beforeWidth', bool ? `${window.innerWidth}px` : '0px');
        markerElement.style.setProperty('--beforeColor', bool ? '#4F0FFF' : '#ff792c');
        markerElement.children[0].style.backgroundColor = bool ? '#4F0FFF' : '#ff792c';
        markerElement.children[1].style.borderColor = bool ? '#4F0FFF' : '#ff792c';
        markerElement.children[2].style.borderColor = bool ? '#4F0FFF' : '#ff792c';

    }


    isSameData(data1, data2) {
        if (data1.length !== data2.length) {
            // console.log("Différence de longueur :", data1.length, "vs", data2.length);
            return false;
        }

        return data1.every((item, index) => {
            const item2 = data2[index];
            if (!item2) {
                // console.log(`Élément manquant à l'index ${index}`);
                return false;
            }

            const properties1 = item.properties;
            const properties2 = item2.properties;

            if (JSON.stringify(properties1) !== JSON.stringify(properties2)) {
                // console.log(`Différence trouvée à l'index ${index}:`, properties1, "vs", properties2);
                return false;
            }

            return true;
        });
    }



    setMapDataContainer() {
        fetch('./interactiveMap/html/mapData.html')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
            })
            .then(html => {
                const template = document.createElement('template');
                template.innerHTML = html.trim();
                this.experience.container.appendChild(template.content);
                this.listCount = new ListCount(document.querySelector('.mapContainer .mapDataContainer .listCount'), this.data.length)

            })
            .catch(error => {
                console.error('Error loading mapData.html:', error);
            });
    }

    update(data) {
        this.listCount.setTo(data.length)



    }


}
